import { Reveal, CTAButton } from "@/components/okaia/Reveal";
import { TIDYCAL_URL } from "@/config/links";

const STEPS = [
  {
    n: "01",
    label: "Préparer",
    title:
      "Lors de la réservation, vous répondez à quatre questions courtes pour présenter votre situation. Trois sont obligatoires et la dernière est facultative.",
    img: "/illus-clarification.jpg",
    alt: "Illustration : préparation du diagnostic lors de la réservation",
  },
  {
    n: "02",
    label: "Échanger",
    title:
      "Nous échangeons pendant 30 minutes en visioconférence sur votre objectif, votre principal blocage et les démarches déjà tentées.",
    img: "/illus-visio.jpg",
    alt: "Illustration : échange en visioconférence",
  },
  {
    n: "03",
    label: "Avancer",
    title:
      "Après l'entretien, vous recevez une synthèse écrite avec votre priorité et cinq actions : trois prioritaires et deux à engager ensuite.",
    img: "/illus-plan.jpg",
    alt: "Illustration : synthèse écrite, priorité et cinq actions",
  },
];

export const Steps = () => (
  <section id="methode" data-testid="section-methode" className="bg-[#0B2215] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="okaia-overline mb-6 text-[#C8A97E]">Comment ça fonctionne</p>
        <h2 className="max-w-3xl font-serif-display text-4xl leading-[1.1] tracking-tight text-[#F9F8F6] md:text-5xl">
          Votre Diagnostic Business — 49&nbsp;€
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-px bg-[#C8A97E]/20 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="bg-[#0B2215]">
            <div data-testid={`step-${s.n}`} className="flex h-full flex-col p-8 md:p-10">
              <img src={s.img} alt={s.alt} className="aspect-[16/9] w-full border border-[#C8A97E]/20 object-cover md:aspect-auto" loading="lazy" />
              <div className="mt-6 flex items-baseline gap-4">
                <span className="font-serif-display text-5xl font-medium italic leading-none text-[#C8A97E]">{s.n}</span>
                <span className="okaia-overline text-[#C8A97E]">{s.label}</span>
              </div>
              <h3 className="mt-4 font-serif-display text-lg leading-snug tracking-tight text-[#F9F8F6] md:text-xl">
                {s.title}
              </h3>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col items-start gap-4">
          <CTAButton label="Réserver mon diagnostic — 49 €" testId="steps-cta" href={TIDYCAL_URL} />
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#A3B1AA]">
            30 minutes • Visioconférence • Synthèse écrite et cinq actions
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
